import { action, observable } from 'mobx';
import { v4 as uuidv4 } from 'uuid';

import { getAccessToken } from '../../utils/AccountsStorageUtils';
import { getPaymentAccessToken } from '../../utils/PaymentStorageUtils';

class UIStore {
  @observable isUserLoggedIn!: boolean;
  browserSessionId!: string;
  constructor() {
    this.init();
  }

  @action.bound
  init() {
    this.isUserLoggedIn =
      getAccessToken() !== undefined && getPaymentAccessToken() !== undefined;
    this.browserSessionId = uuidv4();
  }

  @action
  setIsUserLoggedIn(response: boolean) {
    this.isUserLoggedIn = response;
  }
}

export default UIStore;
